import { render, staticRenderFns } from "./Shipper.vue?vue&type=template&id=975cf320&"
import script from "./Shipper.vue?vue&type=script&lang=js&"
export * from "./Shipper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports